import { AccountingSystem, AuthModule, PayrollSystem } from '$constants'
import { ThirdPartyConnectionInfo } from '$models'
import { getExternalSystemConnectionInfo } from '$utils'
import { StateCreator } from 'zustand'

interface SharedState {
  isLoading: boolean
}

export interface SharedSlice extends SharedState {
  setIsLoading: (newData: boolean) => void

  /**
   * Resets Shared Slice state
   */
  resetSharedSlice: () => void

  /**
   * Check external system connection
   * @param authModule Time or Stock
   * @param system The external system (e.g., AccountingSystem.Xero)
   * @returns Promise resolving to ThirdPartyConnectionInfo or null
   */
  checkExternalSystemConnection: (
    authModule: AuthModule,
    system: AccountingSystem | PayrollSystem
  ) => Promise<ThirdPartyConnectionInfo | null>
}

const initialState: SharedState = {
  isLoading: false,
}

export const createSharedSlice: StateCreator<
  SharedSlice,
  [],
  [],
  SharedSlice
> = (set) => ({
  // State variables
  ...initialState,

  // State setters
  setIsLoading: (newData) => set({ isLoading: newData }),
  resetSharedSlice: () => set(initialState),

  checkExternalSystemConnection: async (
    authModule: AuthModule,
    system: AccountingSystem | PayrollSystem
  ): Promise<ThirdPartyConnectionInfo | null> => {
    return getExternalSystemConnectionInfo(String(system), String(authModule))
  },
})
